import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import tel1 from '../assets/photos/telecom_solutions/1.jpg';
import tel2 from '../assets/photos/telecom_solutions/2.jpg';
import tel3 from '../assets/photos/telecom_solutions/3.jpg';
import tel4 from '../assets/photos/telecom_solutions/4.jpg';
import tel5 from '../assets/photos/telecom_solutions/5.jpg';
import tel6 from '../assets/photos/telecom_solutions/6.jpg';
import tel7 from '../assets/photos/telecom_solutions/7.jpg';
import tel8 from '../assets/photos/telecom_solutions/8.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											TELECOMMUNICATION SOLUTIONS
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={telecom_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									JIEZHI TECH CO LTD is a leading provider of cutting-edge telecommunications equipment and solutions designed to meet the evolving needs of businesses and individuals in the rapidly changing communications landscape. Our comprehensive range of products is engineered to enable seamless connectivity, enhance network performance, and drive operational efficiency. Our telecommunications solutions portfolio includes:
								</h6>

								<HorizontalImageStrip
									images={[tel1, tel2, tel3, tel4, tel5, tel6, tel7]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									CPE/ROUTERS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel8}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer a wide selection of Customer Premises Equipment (CPE) and routers that enable secure, high-speed internet access and reliable network connectivity for businesses of all sizes.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									MIFI DEVICES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel7}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our MiFi (Mobile Wi-Fi) devices provide portable, wireless internet access, allowing users to stay connected on the go and share their internet connection with multiple devices.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									DONGLES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel4}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We provide a range of dongles that enable quick and easy internet access through cellular networks, offering flexibility and convenience for mobile users.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									FIBER CABLE AND ACCESSORIES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel1}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our high-quality fiber optic cables and accessories are designed to support high-bandwidth data transmission, ensuring optimal network performance and reliability.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									3G/4G FIXED WIRELESS PHONES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel3}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We offer fixed wireless phones that leverage 3G and 4G networks to provide voice communication services in areas where traditional landline infrastructure may be limited or unavailable.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									IP PHONES
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={tel6}
								/>		

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our IP phones are designed to deliver crystal-clear voice quality, advanced features, and seamless integration with existing VoIP (Voice over Internet Protocol) systems, enhancing business communication and collaboration.
									<br/><br/>
									With sleek and modern designs, our IP phones are not only aesthetically pleasing but also highly functional. Whether you are making calls within the office or connecting with clients across the globe, our IP phones ensure that every conversation is crisp and clear, allowing you to focus on what truly matters – your work. Say goodbye to static-filled lines and hello to a new era of communication efficiency.
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}